import React, { useState, useEffect } from "react";

import api from "../services/api";

//Feather icons
import {
  X,
  Search
} from "react-feather";

//React UI
import {
  CFormCheck
} from "@coreui/react";

//Components
import Popup from "./Popup";

import { useAuth } from "../providers/auth";

import {
  useForm
} from "react-hook-form";
import LoadingCenter from "./LoadingCenter";

const PopupTags = ({ trigger, setTrigger, setSelectedTags, blockLongPooling, isLoading }) => {

  const { register, handleSubmit } = useForm();

  const { user } = useAuth();

  const [tags, setTags] = useState([]);
  const [search, setSearch] = useState("");
  const [isSearch, setIsSearch] = useState(true);
  const [error, setError] = useState("");

  /**
   *
   * Filtro de tags
   * GET /tags/search?query=exemple&tags=1,2,3,4&social_media=Facebook
   *
   */

  const onSubmitTags = data => setSelectedTags(data.tags);

  const handleSearch = async (e) => {
    setError("");

    if (e.key === "Enter") {

      blockLongPooling.current = true;

      setIsSearch(true);
      setTags([]);

      try {
        const response = await api.get(`/tags/search?query=${search}&admin_id=${user}`, { headers: { "Authorization": "Bearer " + user.token } });

        setTags(response.data);
      } catch (error) {
        console.log(error);
        setError("Ocorreu um erro. Tente novamente.");
      } finally {
        setIsSearch(false);
      }
    }
  }

  const fetchAllTags = async () => {
    setIsSearch(true);
    setTags([]);

    try {
      const response = await api.get(`/tags/admin`, { headers: { "Authorization": "Bearer " + user.token } });

      setTags(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsSearch(false);
    }
  }

  const fetchFilter = async () => {
    setIsSearch(true);
    setTags([]);

    try {
      const response = await api.get(`/tags/search?query=${search}&tags=${tags}&social_media=`, { headers: { "Authorization": "Bearer " + user.token } });

      setTags(response.data);
    } catch (e) {
      console.log(e);
    } finally {
      setIsSearch(false);
    }
  }

  useEffect(() => {
    fetchAllTags();
  }, []);

  useEffect(() => {
    search <= 0 ? fetchAllTags() : handleSearch();
  }, [search]);

  return (
    <Popup title="Filtrar por tags" trigger={trigger} setTrigger={setTrigger} >
      <div className="padding-inner">

        <div className="inner-search mb-20" style={{ height: "45px" }}>
          <div className="search-icon">
            <Search size={24} />
          </div>
          <input className="search-input" onKeyPress={handleSearch} type="text" placeholder="Pressione enter p/ pesquisar" onChange={e => setSearch(e.target.value)} value={search} />
        </div>

        {error && <div className="error-text">{error}</div>}

        {isSearch && <LoadingCenter />}

        <form onSubmit={handleSubmit(onSubmitTags)}>
          {tags.map((tag, index) => {
            return (
              <div key={index} className="tag-delete">
                <div className="tag-delete-inner">
                  <CFormCheck id={`checkbox-tags-${index}`} style={{ marginBottom: "5px", marginRight: "10px" }} value={tag.id} {...register("tags")} />

                  <span>#{tag.name}</span>
                </div>
              </div>
            );
          })}

          <div className="popup-footer">
            <button className="btn btn-primary" type="submit">
              {isLoading ? "Carregando..." : "Concluir"}
            </button>
            <button className="btn btn-light mr-20" type="submit" onClick={() => setTrigger(false)}>Cancelar</button>
          </div>
        </form>

      </div>
    </Popup>
  );
}

export default PopupTags;